import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import QuickTixWhiteLogo from "../../../../../../Images/GX_Logo_White_No_Bg.png";
import QrCode from "../../../../../../Images/qrCode1.png";
const Band1 = ({ ticket, ChangeColor, type, image, bookerName, navigator }) => {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Box sx={{ marginTop: "1rem", marginLeft: "1rem" }}>
      <Grid
        container
        spacing={2}
        sx={{
          color: "white",
          border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
          boxShadow: pevSelected
            ? "0 4px 12px rgba(74, 144, 226, 0.5)"
            : "0 2px 8px rgba(0, 0, 0, 0.1)",
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
            border: "1px solid #4A90E2",
            borderRadius: "1px",
          },
        }}
      >
        {/* 1st */}
        <Grid sx={{ backgroundColor: "#E8E8E8" }} item xs={1} md={1}>
          <Box sx={{ width: "100%", height: "100%" }}></Box>
        </Grid>
        {/* 2st */}
        <Grid
          sx={{
            backgroundColor: ChangeColor
              ? ChangeColor
              : ticket.bgColor
              ? ticket.bgColor
              : "#807C79",
          }}
          xs={3}
          md={3}
        >
          <Box
            sx={{
              textAlign: "center",
              transform: "rotate(90deg)",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box>
              {navigator === "ct" ? (
                <></>
              ) : !qrCodeData ? (
                <img
                  src={QrCode}
                  alt="qr"
                  style={{
                    width: "100%",
                    maxWidth: "60%",
                    minWidth: "40px",
                    height: "auto",
                    maxHeight: "40px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={ticket?.qrCode || QrCode}
                  alt="QR"
                  style={{
                    width: "100%",
                    maxWidth: "80%",
                    height: "auto",
                    maxHeight: "80px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Box>
            <Box>
              {navigator === "ct" ? (
                <></>
              ) : (
                <Typography
                  sx={{ fontSize: "8px" }}
                  variant="body1"
                ></Typography>
              )}
              <img
                src={QuickTixWhiteLogo}
                alt=".."
                style={{
                  width: "40%",
                  maxWidth: "80%",
                  height: "auto",
                  maxHeight: "80px",
                  objectFit: "contain",
                  minHeight: "40px",
                }}
              />
            </Box>
          </Box>
        </Grid>
        {/* 3st */}
        <Grid
          sx={{
            backgroundColor: ChangeColor
              ? ChangeColor
              : ticket.bgColor
              ? ticket.bgColor
              : "#807C79",
            display: "flex",
            justifyContent: "center",
          }}
          xs={5}
          md={5}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              columnGap: { xs: "0.5rem", md: "2rem" },
              alignItems: "center",
            }}
            py={"0.5em"}
          >
            <Box>
              <Typography sx={{ fontSize: { xs: "1.1rem", sm: "2rem" } }}>
                {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
              </Typography>
              <Typography
                variant="h5"
                sx={{ fontSize: "1rem", whiteSpace: "nowrap" }}
              >
                ${" "}
                {ticket?.price != null && ticket?.price !== ""
                  ? ticket?.ticketPrices
                    ? Object.values(ticket?.ticketPrices)[0]
                    : Number(ticket?.price) === 0
                    ? "Free"
                    : Number(ticket?.price) % 1 === 0
                    ? Number(ticket?.price).toFixed(0)
                    : ticket.price
                  : "211"}
              </Typography>
            </Box>

            <Stack direction={"column"} justifyContent={"center"}>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 400,
                  fontSize: { xs: "0.9rem", sm: "1.8rem" },
                  color: "#ffff",
                  fontFamily: "Bebas Neue",
                  lineHeight: "1.1em",
                }}
                textAlign={"start"}
              >
                {ticket?.title}
              </Typography>

              {navigator === "ct" ? (
                <></>
              ) : (
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "0.5rem", sm: "0.8rem" },
                    color: "#ffff",
                    fontFamily: "Lato",
                  }}
                >
                  {ticket?.code ? ticket?.code : "00000000"}
                </Typography>
              )}
              {ticket?.ticketName ? ticket?.ticketName : "Band"}
            </Stack>
          </Box>
        </Grid>
        {/* 4st */}
        <Grid
          sx={{
            backgroundColor: ChangeColor
              ? ChangeColor
              : ticket.bgColor
              ? ticket.bgColor
              : "#807C79",
            display: "flex",
            justifyContent: "center",
          }}
          xs={2}
          md={2}
        >
          <Stack justifyContent={"center"} alignItems={"center"}>
            <img
              src={image ? image : QuickTixWhiteLogo}
              alt=".."
              style={{
                // width: "100%",
                width: "60%",
                maxWidth: "80%",
                height: "auto",
                maxHeight: "80px",
                minWidth: "40px",
                objectFit: "contain",
                minHeight: "50px",
              }}
            />
          </Stack>
        </Grid>
        {/* 5st */}
        <Grid sx={{ backgroundColor: "#E8E8E8" }} item xs={1} md={1}>
          {" "}
          <Box sx={{ width: "100%", height: "100%" }}></Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Band1;
